import React, { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";

const Hero = () => {
  const container = useRef();
  const titleRef = useRef();

  useGSAP(
    () => {
      // Stagger entrance for all images
      gsap.from("img", {
        y: 60,
        opacity: 0,
        duration: 0.6,
        stagger: 0.03,
        ease: "power2.out",
      });

      // Floating animation for image columns
      const columns = container.current.querySelectorAll(".flex-col");
      columns.forEach((col, i) => {
        gsap.to(col, {
          y: i % 2 === 0 ? -40 : 40,
          duration: 1.5 + i * 0.2,
          repeat: -1,
          yoyo: true,
          ease: "sine.inOut",
        });
      });

      // Parallax effect on scroll
      gsap.to(".flex-col", {
        scrollTrigger: {
          trigger: container.current,
          start: "top top",
          end: "bottom top",
          scrub: 0.5,
        },
        y: (i) => (i % 2 === 0 ? -250 : 250),
      });

      // Glow effect for title
      gsap.to(titleRef.current, {
        textShadow: "0 0 20px rgba(250, 201, 107, 0.5), 0 0 40px rgba(254, 156, 154, 0.3)",
        duration: 2,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut",
      });
    },
    { scope: container }
  );

  return (
    <div ref={container} className="relative overflow-hidden lg:min-h-screen min-h-[50vh] flex items-center justify-center">
      <div className="lg:py-20 py-10 lg:px-48 px-5 flex relative lg:gap-10 gap-5 w-full justify-center items-center opacity-25 overflow-hidden">
        <div className="flex flex-col lg:gap-8 gap-5">
          <img src="/7-1.png" alt="pic-1" className="lg:w-36 lg:h-36 w-10 h-10 rounded-lg object-cover" />
          <img src="/7-2.png" alt="pic-2" className="lg:w-36 lg:h-36 w-10 h-10 rounded-lg object-cover" />
          <img src="/7-3.png" alt="pic-3" className="lg:w-36 lg:h-36 w-10 h-10 rounded-lg object-cover" />
        </div>
        <div className="flex flex-col lg:gap-8 gap-5 relative lg:top-[-70px] top-[-30px]">
          <img src="/6-1.png" alt="pic-1" className="lg:w-36 lg:h-36 w-10 h-10 rounded-lg object-cover" />
          <img src="/6-2.png" alt="pic-2" className="lg:w-36 lg:h-36 w-10 h-10 rounded-lg object-cover" />
          <img src="/6-3.png" alt="pic-3" className="lg:w-36 lg:h-36 w-10 h-10 rounded-lg object-cover" />
        </div>
        <div className="flex flex-col lg:gap-8 gap-5">
          <img src="/5-1.png" alt="pic-1" className="lg:w-36 lg:h-36 w-10 h-10 rounded-lg object-cover" />
          <img src="/5-2.png" alt="pic-2" className="lg:w-36 lg:h-36 w-10 h-10 rounded-lg object-cover" />
          <img src="/5-3.png" alt="pic-3" className="lg:w-36 lg:h-36 w-10 h-10 rounded-lg object-cover" />
        </div>
        <div className="flex flex-col lg:gap-8 gap-5 relative lg:top-[-70px] top-[-30px]">
          <img src="/4-1.png" alt="pic-1" className="lg:w-36 lg:h-36 w-10 h-10 rounded-lg object-cover" />
          <img src="/4-2.png" alt="pic-2" className="lg:w-36 lg:h-36 w-10 h-10 rounded-lg object-cover" />
          <img src="/4-3.png" alt="pic-3" className="lg:w-36 lg:h-36 w-10 h-10 rounded-lg object-cover" />
        </div>
        <div className="flex flex-col lg:gap-8 gap-5">
          <img src="/3-1.png" alt="pic-1" className="lg:w-36 lg:h-36 w-10 h-10 rounded-lg object-cover" />
          <img src="/3-2.png" alt="pic-2" className="lg:w-36 lg:h-36 w-10 h-10 rounded-lg object-cover" />
          <img src="/3-3.png" alt="pic-3" className="lg:w-36 lg:h-36 w-10 h-10 rounded-lg object-cover" />
        </div>
        <div className="flex flex-col lg:gap-8 gap-5 relative lg:top-[-70px] top-[-30px]">
          <img src="/2-1.png" alt="pic-1" className="lg:w-36 lg:h-36 w-10 h-10 rounded-lg object-cover" />
          <img src="/2-2.png" alt="pic-2" className="lg:w-36 lg:h-36 w-10 h-10 rounded-lg object-cover" />
          <img src="/2-3.png" alt="pic-3" className="lg:w-36 lg:h-36 w-10 h-10 rounded-lg object-cover" />
        </div>
        <div className="flex flex-col lg:gap-8 gap-5">
          <img src="/nutral-pic.png" alt="pic-1" className="lg:w-36 lg:h-36 w-10 h-10 rounded-lg object-cover" />
          <img src="/nutral-pic-2.png" alt="pic-2" className="lg:w-36 lg:h-36 w-10 h-10 rounded-lg object-cover" />
          <img src="/nutral-pic-3.png" alt="pic-3" className="lg:w-36 lg:h-36 w-10 h-10 rounded-lg object-cover" />
        </div>
      </div>
      <div className="absolute w-full h-full top-0 flex justify-center items-center pointer-events-none">
        <h1 ref={titleRef} className="lg:text-4xl md:text-3xl text-2xl lg:w-[60%] w-[90%] text-center font-black tracking-tighter leading-[1.2] uppercase italic">
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#fac96b] via-[#fe9c9a] to-[#fac96b] bg-[length:200%_auto] animate-gradient-text">
            Create, customize, and publish
          </span>{" "}
          your digital persona to life effortlessly.
        </h1>
      </div>
    </div>
  );
};

export default Hero;
